import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { BoardPurchaseInterface } from '../../board-purchase/interfaces/board-purchase.interface';
import { BoardPurchaseCheckCountNoteInterface } from '../interfaces/board-purchase-check-count-note.interface';
import { UserPublicInterface } from 'src/modules/user/interfaces/user-public.interface';
import { IsBoolean } from 'class-validator';

@Exclude()
export class BoardPurchaseCheckCountNoteDto
  extends CommonEntityDto
  implements BoardPurchaseCheckCountNoteInterface
{
  @ApiProperty({
    title: 'note',
    description: 'note',
  })
  @Expose()
  text!: string;

  @ApiProperty({
    title: 'userId',
    description: 'userId',
  })
  @Expose()
  userId!: string;

  @ApiPropertyOptional({
    type: 'boolean',
    description: 'Is Current Description?',
  })
  @Expose()
  @IsBoolean()
  isCurrent!: boolean;

  @ApiProperty({
    title: 'user',
    description: 'user',
  })
  @Expose()
  user?: UserPublicInterface | undefined;

  @ApiProperty({
    title: 'boardPurchaseId',
    description: 'boardPurchaseId',
  })
  @Expose()
  boardPurchaseId!: string;

  @ApiProperty({
    title: 'Board Purchase',
    description: 'Board Purchase',
  })
  @Expose()
  boardPurchase?: BoardPurchaseInterface | undefined;
}
